import { Component, OnInit, Output } from '@angular/core';
import { Orgstyle } from './orgstyle/model/orgstyle';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Meta } from '@angular/platform-browser';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';

import { UntilDestroy } from '@ngneat/until-destroy';
import { ModalService } from '@src/app/helpers/modal.service';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgaccount',
  templateUrl: './orgaccount.component.html',
  styleUrls: ['./orgaccount.component.css']
})
export class OrgaccountComponent implements OnInit {
  @Output() orgstyle: Orgstyle;
  isWhitelabel: boolean;
  hubspot: boolean;
  orgId: string;
  automationorganizationId: string; // Default to the chosen organization ID


  constructor(
    private meta: Meta,
    private uieventhub: UieventhubService,
    private modalservice: ModalService
  ) { }

  ngOnInit() {
    //this.uieventhub.setShowLoader(true);
    this.meta.addTags([
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' },
    ]);
    this.isWhitelabel = false;
    this.hubspot = false;
    SessionHelper.getHubspot() ? this.hubspot = true : this.hubspot = false;
    //console.log('hubspot',this.hubspot);
    this.orgstyle = new Orgstyle;
    this.orgId = SessionHelper.getChoosenOrg();
    this.orgstyle.sidenav = 'top';
    if (SessionHelper.getDynamicStyle() && SessionHelper.getDynamicStyle() !== 'undefined') {
      this.orgstyle = JSON.parse(SessionHelper.getDynamicStyle());
      this.isWhitelabel = true;
    }
    //this.uieventhub.setShowLoader(false);
  }
  clickAutomation(): void {
    this.automationorganizationId = SessionHelper.getChoosenOrg();
    this.modalservice.open('projectautomationmodal');
  }


}
